import { Globe2, ArrowDownRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Reveal, PageHero, Eyebrow, SectionHeading } from '../components/Shared';
import { ContactForm } from '../components/ContactForm';
import { LocationsMap } from '../components/LocationsMap';
import { offices, officeCountry } from '../data/content';
import { L } from '../i18n/LocaleProvider';

export default function Contact() {
  return <L><main id="main-content" className="contact-page" data-testid="contact-page">
    <PageHero id="contact-hero" eyebrow="LET’S START A CONVERSATION" lines={[{ text: 'Let’s build' }, { text: 'what’s next.', accent: true }]} description="Your journey. Our partnership. Tell us what you have in mind." />
    <section className="container contact-layout quiet-contact-layout">
      <Reveal className="contact-form-wrapper"><ContactForm /></Reveal>
      <Reveal className="contact-simple-aside">
        <Globe2 className="contact-aside-globe" size={72} strokeWidth={.8} aria-hidden="true" />
        <Eyebrow id="contact-team-eyebrow">CONNECTED GLOBALLY</Eyebrow>
        <h2 data-testid="contact-team-heading">Five countries.<br /><span className="muted-heading">One team.</span></h2>
        <p data-testid="contact-team-countries">{offices.map((office, i) => <span key={office.id}>{i > 0 && ' · '}<span>{officeCountry(office)}</span></span>)}</p>
        <Link to="#locations-map" className="text-link" data-testid="contact-explore-locations">Explore our locations <ArrowDownRight size={17} /></Link>
      </Reveal>
    </section>
    <section id="locations-map" className="container contact-map-wrap quiet-contact-map" aria-label="Explore our global offices">
      {offices.map(office => <span id={office.id} key={office.id} className="office-map-anchor" aria-hidden="true" />)}
      <SectionHeading id="contact-global" eyebrow="OUR GLOBAL FOOTPRINT" title="Closer than you think." />
      <Reveal><LocationsMap id="contact-locations" contact /></Reveal>
    </section>
  </main></L>;
}